/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as TermsRouteImport } from './routes/terms'
import { Route as SupportRouteImport } from './routes/support'
import { Route as SigninRouteImport } from './routes/signin'
import { Route as PrivacyRouteImport } from './routes/privacy'
import { Route as PaRouteImport } from './routes/pa'
import { Route as AppRouteImport } from './routes/_app'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AppTrainingRouteImport } from './routes/_app.training'
import { Route as AppTasksRouteImport } from './routes/_app.tasks'
import { Route as AppSimulationsRouteImport } from './routes/_app.simulations'
import { Route as AppSettingsRouteImport } from './routes/_app.settings'
import { Route as AppMarketplaceRouteImport } from './routes/_app.marketplace'
import { Route as AppInterviewAdminRouteImport } from './routes/_app.interview-admin'
import { Route as AppDevelopersRouteImport } from './routes/_app.developers'
import { Route as AppDashboardRouteImport } from './routes/_app.dashboard'
import { Route as AppCompanyRouteImport } from './routes/_app.company'
import { Route as AppClientsRouteImport } from './routes/_app.clients'
import { Route as AppApikeyRouteImport } from './routes/_app.apikey'
import { Route as AppAdminRouteImport } from './routes/_app.admin'
import { Route as AppInterviewsIndexRouteImport } from './routes/_app.interviews.index'
import { Route as AppDiscoveryIndexRouteImport } from './routes/_app.discovery.index'
import { Route as AppDiscoveryIdRouteImport } from './routes/_app.discovery.$id'
import { Route as AppMeetingsIdSummaryRouteImport } from './routes/_app.meetings.$id.summary'
import { Route as AppMeetingsIdSetupRouteImport } from './routes/_app.meetings.$id.setup'
import { Route as AppMeetingsIdLiveRouteImport } from './routes/_app.meetings.$id.live'
import { Route as AppInterviewsIdSummaryRouteImport } from './routes/_app.interviews.$id.summary'
import { Route as AppInterviewsIdSetupRouteImport } from './routes/_app.interviews.$id.setup'
import { Route as AppInterviewsIdLiveRouteImport } from './routes/_app.interviews.$id.live'

const TermsRoute = TermsRouteImport.update({
  id: '/terms',
  path: '/terms',
  getParentRoute: () => rootRouteImport,
} as any)
const SupportRoute = SupportRouteImport.update({
  id: '/support',
  path: '/support',
  getParentRoute: () => rootRouteImport,
} as any)
const SigninRoute = SigninRouteImport.update({
  id: '/signin',
  path: '/signin',
  getParentRoute: () => rootRouteImport,
} as any)
const PrivacyRoute = PrivacyRouteImport.update({
  id: '/privacy',
  path: '/privacy',
  getParentRoute: () => rootRouteImport,
} as any)
const PaRoute = PaRouteImport.update({
  id: '/pa',
  path: '/pa',
  getParentRoute: () => rootRouteImport,
} as any)
const AppRoute = AppRouteImport.update({
  id: '/_app',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AppTrainingRoute = AppTrainingRouteImport.update({
  id: '/training',
  path: '/training',
  getParentRoute: () => AppRoute,
} as any)
const AppTasksRoute = AppTasksRouteImport.update({
  id: '/tasks',
  path: '/tasks',
  getParentRoute: () => AppRoute,
} as any)
const AppSimulationsRoute = AppSimulationsRouteImport.update({
  id: '/simulations',
  path: '/simulations',
  getParentRoute: () => AppRoute,
} as any)
const AppSettingsRoute = AppSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AppRoute,
} as any)
const AppMarketplaceRoute = AppMarketplaceRouteImport.update({
  id: '/marketplace',
  path: '/marketplace',
  getParentRoute: () => AppRoute,
} as any)
const AppInterviewAdminRoute = AppInterviewAdminRouteImport.update({
  id: '/interview-admin',
  path: '/interview-admin',
  getParentRoute: () => AppRoute,
} as any)
const AppDevelopersRoute = AppDevelopersRouteImport.update({
  id: '/developers',
  path: '/developers',
  getParentRoute: () => AppRoute,
} as any)
const AppDashboardRoute = AppDashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => AppRoute,
} as any)
const AppCompanyRoute = AppCompanyRouteImport.update({
  id: '/company',
  path: '/company',
  getParentRoute: () => AppRoute,
} as any)
const AppClientsRoute = AppClientsRouteImport.update({
  id: '/clients',
  path: '/clients',
  getParentRoute: () => AppRoute,
} as any)
const AppApikeyRoute = AppApikeyRouteImport.update({
  id: '/apikey',
  path: '/apikey',
  getParentRoute: () => AppRoute,
} as any)
const AppAdminRoute = AppAdminRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => AppRoute,
} as any)
const AppInterviewsIndexRoute = AppInterviewsIndexRouteImport.update({
  id: '/interviews/',
  path: '/interviews/',
  getParentRoute: () => AppRoute,
} as any)
const AppDiscoveryIndexRoute = AppDiscoveryIndexRouteImport.update({
  id: '/discovery/',
  path: '/discovery/',
  getParentRoute: () => AppRoute,
} as any)
const AppDiscoveryIdRoute = AppDiscoveryIdRouteImport.update({
  id: '/discovery/$id',
  path: '/discovery/$id',
  getParentRoute: () => AppRoute,
} as any)
const AppMeetingsIdSummaryRoute = AppMeetingsIdSummaryRouteImport.update({
  id: '/meetings/$id/summary',
  path: '/meetings/$id/summary',
  getParentRoute: () => AppRoute,
} as any)
const AppMeetingsIdSetupRoute = AppMeetingsIdSetupRouteImport.update({
  id: '/meetings/$id/setup',
  path: '/meetings/$id/setup',
  getParentRoute: () => AppRoute,
} as any)
const AppMeetingsIdLiveRoute = AppMeetingsIdLiveRouteImport.update({
  id: '/meetings/$id/live',
  path: '/meetings/$id/live',
  getParentRoute: () => AppRoute,
} as any)
const AppInterviewsIdSummaryRoute = AppInterviewsIdSummaryRouteImport.update({
  id: '/interviews/$id/summary',
  path: '/interviews/$id/summary',
  getParentRoute: () => AppRoute,
} as any)
const AppInterviewsIdSetupRoute = AppInterviewsIdSetupRouteImport.update({
  id: '/interviews/$id/setup',
  path: '/interviews/$id/setup',
  getParentRoute: () => AppRoute,
} as any)
const AppInterviewsIdLiveRoute = AppInterviewsIdLiveRouteImport.update({
  id: '/interviews/$id/live',
  path: '/interviews/$id/live',
  getParentRoute: () => AppRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/pa': typeof PaRoute
  '/privacy': typeof PrivacyRoute
  '/signin': typeof SigninRoute
  '/support': typeof SupportRoute
  '/terms': typeof TermsRoute
  '/admin': typeof AppAdminRoute
  '/apikey': typeof AppApikeyRoute
  '/clients': typeof AppClientsRoute
  '/company': typeof AppCompanyRoute
  '/dashboard': typeof AppDashboardRoute
  '/developers': typeof AppDevelopersRoute
  '/interview-admin': typeof AppInterviewAdminRoute
  '/marketplace': typeof AppMarketplaceRoute
  '/settings': typeof AppSettingsRoute
  '/simulations': typeof AppSimulationsRoute
  '/tasks': typeof AppTasksRoute
  '/training': typeof AppTrainingRoute
  '/discovery/$id': typeof AppDiscoveryIdRoute
  '/discovery/': typeof AppDiscoveryIndexRoute
  '/interviews/': typeof AppInterviewsIndexRoute
  '/interviews/$id/live': typeof AppInterviewsIdLiveRoute
  '/interviews/$id/setup': typeof AppInterviewsIdSetupRoute
  '/interviews/$id/summary': typeof AppInterviewsIdSummaryRoute
  '/meetings/$id/live': typeof AppMeetingsIdLiveRoute
  '/meetings/$id/setup': typeof AppMeetingsIdSetupRoute
  '/meetings/$id/summary': typeof AppMeetingsIdSummaryRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/pa': typeof PaRoute
  '/privacy': typeof PrivacyRoute
  '/signin': typeof SigninRoute
  '/support': typeof SupportRoute
  '/terms': typeof TermsRoute
  '/admin': typeof AppAdminRoute
  '/apikey': typeof AppApikeyRoute
  '/clients': typeof AppClientsRoute
  '/company': typeof AppCompanyRoute
  '/dashboard': typeof AppDashboardRoute
  '/developers': typeof AppDevelopersRoute
  '/interview-admin': typeof AppInterviewAdminRoute
  '/marketplace': typeof AppMarketplaceRoute
  '/settings': typeof AppSettingsRoute
  '/simulations': typeof AppSimulationsRoute
  '/tasks': typeof AppTasksRoute
  '/training': typeof AppTrainingRoute
  '/discovery/$id': typeof AppDiscoveryIdRoute
  '/discovery': typeof AppDiscoveryIndexRoute
  '/interviews': typeof AppInterviewsIndexRoute
  '/interviews/$id/live': typeof AppInterviewsIdLiveRoute
  '/interviews/$id/setup': typeof AppInterviewsIdSetupRoute
  '/interviews/$id/summary': typeof AppInterviewsIdSummaryRoute
  '/meetings/$id/live': typeof AppMeetingsIdLiveRoute
  '/meetings/$id/setup': typeof AppMeetingsIdSetupRoute
  '/meetings/$id/summary': typeof AppMeetingsIdSummaryRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_app': typeof AppRouteWithChildren
  '/pa': typeof PaRoute
  '/privacy': typeof PrivacyRoute
  '/signin': typeof SigninRoute
  '/support': typeof SupportRoute
  '/terms': typeof TermsRoute
  '/_app/admin': typeof AppAdminRoute
  '/_app/apikey': typeof AppApikeyRoute
  '/_app/clients': typeof AppClientsRoute
  '/_app/company': typeof AppCompanyRoute
  '/_app/dashboard': typeof AppDashboardRoute
  '/_app/developers': typeof AppDevelopersRoute
  '/_app/interview-admin': typeof AppInterviewAdminRoute
  '/_app/marketplace': typeof AppMarketplaceRoute
  '/_app/settings': typeof AppSettingsRoute
  '/_app/simulations': typeof AppSimulationsRoute
  '/_app/tasks': typeof AppTasksRoute
  '/_app/training': typeof AppTrainingRoute
  '/_app/discovery/$id': typeof AppDiscoveryIdRoute
  '/_app/discovery/': typeof AppDiscoveryIndexRoute
  '/_app/interviews/': typeof AppInterviewsIndexRoute
  '/_app/interviews/$id/live': typeof AppInterviewsIdLiveRoute
  '/_app/interviews/$id/setup': typeof AppInterviewsIdSetupRoute
  '/_app/interviews/$id/summary': typeof AppInterviewsIdSummaryRoute
  '/_app/meetings/$id/live': typeof AppMeetingsIdLiveRoute
  '/_app/meetings/$id/setup': typeof AppMeetingsIdSetupRoute
  '/_app/meetings/$id/summary': typeof AppMeetingsIdSummaryRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/pa'
    | '/privacy'
    | '/signin'
    | '/support'
    | '/terms'
    | '/admin'
    | '/apikey'
    | '/clients'
    | '/company'
    | '/dashboard'
    | '/developers'
    | '/interview-admin'
    | '/marketplace'
    | '/settings'
    | '/simulations'
    | '/tasks'
    | '/training'
    | '/discovery/$id'
    | '/discovery/'
    | '/interviews/'
    | '/interviews/$id/live'
    | '/interviews/$id/setup'
    | '/interviews/$id/summary'
    | '/meetings/$id/live'
    | '/meetings/$id/setup'
    | '/meetings/$id/summary'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/pa'
    | '/privacy'
    | '/signin'
    | '/support'
    | '/terms'
    | '/admin'
    | '/apikey'
    | '/clients'
    | '/company'
    | '/dashboard'
    | '/developers'
    | '/interview-admin'
    | '/marketplace'
    | '/settings'
    | '/simulations'
    | '/tasks'
    | '/training'
    | '/discovery/$id'
    | '/discovery'
    | '/interviews'
    | '/interviews/$id/live'
    | '/interviews/$id/setup'
    | '/interviews/$id/summary'
    | '/meetings/$id/live'
    | '/meetings/$id/setup'
    | '/meetings/$id/summary'
  id:
    | '__root__'
    | '/'
    | '/_app'
    | '/pa'
    | '/privacy'
    | '/signin'
    | '/support'
    | '/terms'
    | '/_app/admin'
    | '/_app/apikey'
    | '/_app/clients'
    | '/_app/company'
    | '/_app/dashboard'
    | '/_app/developers'
    | '/_app/interview-admin'
    | '/_app/marketplace'
    | '/_app/settings'
    | '/_app/simulations'
    | '/_app/tasks'
    | '/_app/training'
    | '/_app/discovery/$id'
    | '/_app/discovery/'
    | '/_app/interviews/'
    | '/_app/interviews/$id/live'
    | '/_app/interviews/$id/setup'
    | '/_app/interviews/$id/summary'
    | '/_app/meetings/$id/live'
    | '/_app/meetings/$id/setup'
    | '/_app/meetings/$id/summary'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AppRoute: typeof AppRouteWithChildren
  PaRoute: typeof PaRoute
  PrivacyRoute: typeof PrivacyRoute
  SigninRoute: typeof SigninRoute
  SupportRoute: typeof SupportRoute
  TermsRoute: typeof TermsRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/terms': {
      id: '/terms'
      path: '/terms'
      fullPath: '/terms'
      preLoaderRoute: typeof TermsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/support': {
      id: '/support'
      path: '/support'
      fullPath: '/support'
      preLoaderRoute: typeof SupportRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/signin': {
      id: '/signin'
      path: '/signin'
      fullPath: '/signin'
      preLoaderRoute: typeof SigninRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/privacy': {
      id: '/privacy'
      path: '/privacy'
      fullPath: '/privacy'
      preLoaderRoute: typeof PrivacyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/pa': {
      id: '/pa'
      path: '/pa'
      fullPath: '/pa'
      preLoaderRoute: typeof PaRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app': {
      id: '/_app'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AppRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/training': {
      id: '/_app/training'
      path: '/training'
      fullPath: '/training'
      preLoaderRoute: typeof AppTrainingRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/tasks': {
      id: '/_app/tasks'
      path: '/tasks'
      fullPath: '/tasks'
      preLoaderRoute: typeof AppTasksRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/simulations': {
      id: '/_app/simulations'
      path: '/simulations'
      fullPath: '/simulations'
      preLoaderRoute: typeof AppSimulationsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/settings': {
      id: '/_app/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof AppSettingsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/marketplace': {
      id: '/_app/marketplace'
      path: '/marketplace'
      fullPath: '/marketplace'
      preLoaderRoute: typeof AppMarketplaceRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/interview-admin': {
      id: '/_app/interview-admin'
      path: '/interview-admin'
      fullPath: '/interview-admin'
      preLoaderRoute: typeof AppInterviewAdminRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/developers': {
      id: '/_app/developers'
      path: '/developers'
      fullPath: '/developers'
      preLoaderRoute: typeof AppDevelopersRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/dashboard': {
      id: '/_app/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof AppDashboardRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/company': {
      id: '/_app/company'
      path: '/company'
      fullPath: '/company'
      preLoaderRoute: typeof AppCompanyRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/clients': {
      id: '/_app/clients'
      path: '/clients'
      fullPath: '/clients'
      preLoaderRoute: typeof AppClientsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/apikey': {
      id: '/_app/apikey'
      path: '/apikey'
      fullPath: '/apikey'
      preLoaderRoute: typeof AppApikeyRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/admin': {
      id: '/_app/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof AppAdminRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/interviews/': {
      id: '/_app/interviews/'
      path: '/interviews'
      fullPath: '/interviews/'
      preLoaderRoute: typeof AppInterviewsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/discovery/': {
      id: '/_app/discovery/'
      path: '/discovery'
      fullPath: '/discovery/'
      preLoaderRoute: typeof AppDiscoveryIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/discovery/$id': {
      id: '/_app/discovery/$id'
      path: '/discovery/$id'
      fullPath: '/discovery/$id'
      preLoaderRoute: typeof AppDiscoveryIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/meetings/$id/summary': {
      id: '/_app/meetings/$id/summary'
      path: '/meetings/$id/summary'
      fullPath: '/meetings/$id/summary'
      preLoaderRoute: typeof AppMeetingsIdSummaryRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/meetings/$id/setup': {
      id: '/_app/meetings/$id/setup'
      path: '/meetings/$id/setup'
      fullPath: '/meetings/$id/setup'
      preLoaderRoute: typeof AppMeetingsIdSetupRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/meetings/$id/live': {
      id: '/_app/meetings/$id/live'
      path: '/meetings/$id/live'
      fullPath: '/meetings/$id/live'
      preLoaderRoute: typeof AppMeetingsIdLiveRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/interviews/$id/summary': {
      id: '/_app/interviews/$id/summary'
      path: '/interviews/$id/summary'
      fullPath: '/interviews/$id/summary'
      preLoaderRoute: typeof AppInterviewsIdSummaryRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/interviews/$id/setup': {
      id: '/_app/interviews/$id/setup'
      path: '/interviews/$id/setup'
      fullPath: '/interviews/$id/setup'
      preLoaderRoute: typeof AppInterviewsIdSetupRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/interviews/$id/live': {
      id: '/_app/interviews/$id/live'
      path: '/interviews/$id/live'
      fullPath: '/interviews/$id/live'
      preLoaderRoute: typeof AppInterviewsIdLiveRouteImport
      parentRoute: typeof AppRoute
    }
  }
}

interface AppRouteChildren {
  AppAdminRoute: typeof AppAdminRoute
  AppApikeyRoute: typeof AppApikeyRoute
  AppClientsRoute: typeof AppClientsRoute
  AppCompanyRoute: typeof AppCompanyRoute
  AppDashboardRoute: typeof AppDashboardRoute
  AppDevelopersRoute: typeof AppDevelopersRoute
  AppInterviewAdminRoute: typeof AppInterviewAdminRoute
  AppMarketplaceRoute: typeof AppMarketplaceRoute
  AppSettingsRoute: typeof AppSettingsRoute
  AppSimulationsRoute: typeof AppSimulationsRoute
  AppTasksRoute: typeof AppTasksRoute
  AppTrainingRoute: typeof AppTrainingRoute
  AppDiscoveryIdRoute: typeof AppDiscoveryIdRoute
  AppDiscoveryIndexRoute: typeof AppDiscoveryIndexRoute
  AppInterviewsIndexRoute: typeof AppInterviewsIndexRoute
  AppInterviewsIdLiveRoute: typeof AppInterviewsIdLiveRoute
  AppInterviewsIdSetupRoute: typeof AppInterviewsIdSetupRoute
  AppInterviewsIdSummaryRoute: typeof AppInterviewsIdSummaryRoute
  AppMeetingsIdLiveRoute: typeof AppMeetingsIdLiveRoute
  AppMeetingsIdSetupRoute: typeof AppMeetingsIdSetupRoute
  AppMeetingsIdSummaryRoute: typeof AppMeetingsIdSummaryRoute
}

const AppRouteChildren: AppRouteChildren = {
  AppAdminRoute: AppAdminRoute,
  AppApikeyRoute: AppApikeyRoute,
  AppClientsRoute: AppClientsRoute,
  AppCompanyRoute: AppCompanyRoute,
  AppDashboardRoute: AppDashboardRoute,
  AppDevelopersRoute: AppDevelopersRoute,
  AppInterviewAdminRoute: AppInterviewAdminRoute,
  AppMarketplaceRoute: AppMarketplaceRoute,
  AppSettingsRoute: AppSettingsRoute,
  AppSimulationsRoute: AppSimulationsRoute,
  AppTasksRoute: AppTasksRoute,
  AppTrainingRoute: AppTrainingRoute,
  AppDiscoveryIdRoute: AppDiscoveryIdRoute,
  AppDiscoveryIndexRoute: AppDiscoveryIndexRoute,
  AppInterviewsIndexRoute: AppInterviewsIndexRoute,
  AppInterviewsIdLiveRoute: AppInterviewsIdLiveRoute,
  AppInterviewsIdSetupRoute: AppInterviewsIdSetupRoute,
  AppInterviewsIdSummaryRoute: AppInterviewsIdSummaryRoute,
  AppMeetingsIdLiveRoute: AppMeetingsIdLiveRoute,
  AppMeetingsIdSetupRoute: AppMeetingsIdSetupRoute,
  AppMeetingsIdSummaryRoute: AppMeetingsIdSummaryRoute,
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AppRoute: AppRouteWithChildren,
  PaRoute: PaRoute,
  PrivacyRoute: PrivacyRoute,
  SigninRoute: SigninRoute,
  SupportRoute: SupportRoute,
  TermsRoute: TermsRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
